import { Redirect, useParams } from "react-router-dom";
import type { IParams } from "@models/IParams";
import useNavigationUrl from "@common/hooks/useNavigationUrl";
import { buildPackageViewSearch } from "../utils";

const PackageLinkManagement = () => {
  const { id }: IParams = useParams();
  const { editorUrl } = useNavigationUrl();

  return <Redirect to={`${editorUrl("package", id)}${buildPackageViewSearch("", "leagues")}`} />;
};

export default PackageLinkManagement;
